import { hash } from "rsvp";
import Route from "@ember/routing/route";
import { service } from "@ember/service";
import { findAll } from "@warp-drive/legacy/compat/builders";

export default class ObjectStorageOverviewRoute extends Route {
  @service store;

  queryParams = {
    sortBy: {},
    sortDir: {},
  };

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  model() {
    let { project } = this.modelFor("organization");
    return hash({
      project,
      dataCenters: this.store.request(findAll("data-center")).then((response) => response.content),
    });
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.setupController();
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.resetController();
  }
}
